import { convertMention as convertMentionFunc } from '../utils';

const convertMention = (message) => convertMentionFunc(message);

export default convertMention;
